export class Setting {
    public settingId: string;
    public key: string;
    public category: string;
    public value: string;
    public createdAt: any;
    public updatedAt: any;
}